export const accessToken = "access_token"
export const currentUser = "current_user"